var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClusterMarkers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4821_150732)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4821_150732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5225 29.3947C5.00898 17.0526 3.42871 15.7859 3.42871 11.25C3.42871 5.03678 8.46549 0 14.6787 0C20.8919 0 25.9287 5.03678 25.9287 11.25C25.9287 15.7859 24.3484 17.0526 15.8349 29.3947C15.2762 30.2018 14.0812 30.2017 13.5225 29.3947Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4821_150732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0524 10.4293H11.7742C12.0055 10.4293 12.1961 10.3902 12.3461 10.3121C12.4961 10.2309 12.6071 10.1184 12.6789 9.97461C12.7539 9.82773 12.7914 9.65742 12.7914 9.46367C12.7914 9.28867 12.7571 9.13398 12.6883 8.99961C12.6227 8.86211 12.5211 8.75586 12.3836 8.68086C12.2461 8.60273 12.0727 8.56367 11.8633 8.56367C11.6977 8.56367 11.5446 8.59648 11.4039 8.66211C11.2633 8.72773 11.1508 8.81992 11.0664 8.93867C10.9821 9.05742 10.9399 9.20117 10.9399 9.36992H9.58518C9.58518 8.99492 9.68518 8.66836 9.88518 8.39023C10.0883 8.11211 10.3602 7.89492 10.7008 7.73867C11.0414 7.58242 11.4164 7.5043 11.8258 7.5043C12.2883 7.5043 12.693 7.5793 13.0399 7.7293C13.3867 7.87617 13.6571 8.09336 13.8508 8.38086C14.0446 8.66836 14.1414 9.02461 14.1414 9.44961C14.1414 9.66523 14.0914 9.87461 13.9914 10.0777C13.8914 10.2777 13.7477 10.459 13.5602 10.6215C13.3758 10.7809 13.1508 10.909 12.8852 11.0059C12.6196 11.0996 12.3211 11.1465 11.9899 11.1465H11.0524V10.4293ZM11.0524 11.4559V10.7574H11.9899C12.3617 10.7574 12.6883 10.7996 12.9696 10.884C13.2508 10.9684 13.4867 11.0902 13.6774 11.2496C13.868 11.4059 14.0117 11.5918 14.1086 11.8074C14.2055 12.0199 14.2539 12.2559 14.2539 12.5152C14.2539 12.834 14.193 13.1184 14.0711 13.3684C13.9492 13.6152 13.7774 13.8246 13.5555 13.9965C13.3367 14.1684 13.0805 14.2996 12.7867 14.3902C12.493 14.4777 12.1727 14.5215 11.8258 14.5215C11.5383 14.5215 11.2555 14.4824 10.9774 14.4043C10.7024 14.323 10.4524 14.2027 10.2274 14.0434C10.0055 13.8809 9.82737 13.6777 9.693 13.434C9.56175 13.1871 9.49612 12.8949 9.49612 12.5574H10.8508C10.8508 12.7324 10.8946 12.8887 10.9821 13.0262C11.0696 13.1637 11.1899 13.2715 11.343 13.3496C11.4992 13.4277 11.6727 13.4668 11.8633 13.4668C12.0789 13.4668 12.2633 13.4277 12.4164 13.3496C12.5727 13.2684 12.6914 13.1559 12.7727 13.0121C12.8571 12.8652 12.8992 12.6949 12.8992 12.5012C12.8992 12.2512 12.8539 12.0512 12.7633 11.9012C12.6727 11.748 12.543 11.6355 12.3742 11.5637C12.2055 11.4918 12.0055 11.4559 11.7742 11.4559H11.0524ZM19.6539 10.6262V11.8027H14.9758V10.6262H19.6539ZM17.9571 8.77461V13.7434H16.6774V8.77461H17.9571Z",
    fill: "#F2F2F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4821_150732",
    x: 3.42871,
    y: 0,
    width: 22.5,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4821_150732"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4821_150732",
    x: 9.49609,
    y: 7.50391,
    width: 10.1582,
    height: 8.01758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4821_150732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4821_150732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusterMarkers);
export default __webpack_public_path__ + "static/media/cluster_markers.6641725929e8c98c1bb040de8719e4bd.svg";
export { ForwardRef as ReactComponent };